export enum EducationLevelEnum {
  BAC = 'BAC',
  BAC_PLUS_2 = 'BAC_PLUS_2',
  BAC_PLUS_3 = 'BAC_PLUS_3',
  BAC_PLUS_4 = 'BAC_PLUS_4',
  BAC_PLUS_5 = 'BAC_PLUS_5',
  BAC_PLUS_8 = 'BAC_PLUS_8'
}

export const educationLevelEnumMapping: Record<EducationLevelEnum, string> = {
  [EducationLevelEnum.BAC]: 'BAC',
  [EducationLevelEnum.BAC_PLUS_2]: 'BAC +2',
  [EducationLevelEnum.BAC_PLUS_3]: 'BAC +3',
  [EducationLevelEnum.BAC_PLUS_4]: 'BAC +4',
  [EducationLevelEnum.BAC_PLUS_5]: 'BAC +5',
  [EducationLevelEnum.BAC_PLUS_8]: 'BAC +8'
}
